import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-crop.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const CropIcon = createSvgIcon(<Icon />, 'CropIcon');
